export const LinkedInIcon = () => (
  <svg
    width='40'
    height='40'
    viewBox='0 0 40 40'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M20 0C31.0457 0 40 8.9543 40 20C40 31.0457 31.0457 40 20 40C8.9543 40 0 31.0457 0 20C0 8.9543 8.9543 0 20 0ZM9.86426 30.5303H14.1128V16.5708H9.86426V30.5303ZM25.25 16.2676C22.8102 16.2676 21.0017 17.6877 20.6011 18.5435H20.5464V16.5708H16.5405V30.5303H20.7891V23.2471C20.7891 21.0076 22.3126 20.0122 23.7935 20.0122C25.0073 20.0122 26.2514 20.9469 26.2515 23.1924V30.5303H30.5V22.167C30.5 17.9185 27.6899 16.2676 25.25 16.2676ZM12.019 9.5C10.6474 9.48179 9.51821 10.5868 9.5 11.9585C9.48191 13.3301 10.5869 14.4588 11.9585 14.4771H12.1138C13.3984 14.4465 14.4418 13.4092 14.4771 12.1099V12.019C14.4953 10.6474 13.3907 9.51824 12.019 9.5Z'
      fill='#292722'
    />
  </svg>
);
